import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=5a109de7&"
import script from "./CheckoutSummary.vue?vue&type=script&lang=ts&"
export * from "./CheckoutSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports